import {
  getImage,
  ImageMedia,
  ImageRef,
  Media,
} from "~/api/resources/Media";

export type MediaLike = Media | ImageMedia | ImageRef;

export const mediaUrl = (
  media?: MediaLike | null,
  size: "thumb" | "xlarge" | "original" = "xlarge",
) => {
  if (!media) return undefined;
  if ("url" in media && typeof media.url === "string") return media.url;
  return getImage(media as Media, size === "thumb" ? "thumb" : size)?.url;
};

export const mediaThumbUrl = (media?: MediaLike | null) =>
  mediaUrl(media, "thumb");
